import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import bottomArrow from '../../../../global/media/bottom-arrow.svg';
import { selectors } from '../../reducer';
import * as actions from '../../actions';

import CustomCheckbox from '../../../../components/CustomCheckbox';
import ReceiptTable from '../ReceiptTable';

interface ChosenReceiptBlockProps {
  showWithBonuses: boolean;
  setShowWithBonuses: (a: boolean) => void;
}

const ChosenReceiptBlock: React.FC<ChosenReceiptBlockProps> = ({
  showWithBonuses,
  setShowWithBonuses,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const currentReceiptLoading = useSelector(selectors.currentReceiptLoading);
  const lastUpdateTime = useSelector(selectors.lastUpdateTime);
  const chosenReceipt = useSelector(selectors.chosenReceipt);
  const submitOrderResult = useSelector(selectors.submitOrderResult);

  if (!chosenReceipt) return null;

  return (
    <>
      <div className="active-receipt-top">
        <div className="left-block">
          {!submitOrderResult && (
            <div
              className="back-to-reciepts"
              onClick={() => {
                dispatch(actions.setChosenReceipt.request(null));
              }}
            >
              <img
                className="back-to-reciepts-icon"
                src={bottomArrow}
                alt="back-to-reciepts-icon"
              />
              {t('LoyaltyPage.BACK_TO_RECEIPTS')}
            </div>
          )}
          <div className="last-update">
            {t('LoyaltyPage.LAST_UPDATE')}{' '}
            {currentReceiptLoading ? (
              <CircularProgress size={15} />
            ) : (
              lastUpdateTime
            )}
          </div>
          <CustomCheckbox
            title={t('LoyaltyPage.SHOW_BONUSES_SUMM')}
            id="allDay"
            onChange={() => {
              setShowWithBonuses(!showWithBonuses);
            }}
            checked={showWithBonuses}
          />
        </div>
      </div>

      <ReceiptTable
        currentReceipt={chosenReceipt.items}
        showWithBonuses={showWithBonuses}
      />
    </>
  );
};

export default ChosenReceiptBlock;
